<template>
  <footer class="wt2-sg">
    <wt-button type="transparent" @click="cancel" text="Cancel" />
    <slot></slot>
    <wt-button
      v-if="standalone"
      type="primary"
      @click="apply"
      text="Save"
      :disabled="applyDisabled"
    />
    <wt-button
      v-else
      type="secondary"
      @click="apply"
      text="Apply"
      :disabled="applyDisabled"
    />
  </footer>
</template>

<script>
export default {
  props: {
    standalone: { type: Boolean, default: false },
    applyDisabled: { type: Boolean, default: false },
  },

  methods: {
    apply() {
      app.analytics('analytics.scenes.internalPageExit', { using: 'Apply' });
      this.$emit('apply');
    },

    cancel() {
      app.analytics('analytics.scenes.internalPageExit', { using: 'Cancel' });
      this.$emit('cancel');
    },
  },
};
</script>
